import {Injectable} from "@angular/core";
import {ApiService} from "../../../shared/services/api.service";
import {HttpClient} from "@angular/common/http";
import {applicationUrls} from "../../../shared/application-constants/application-urls.const";
import {LoginResponse} from "../../authentication/models/login-response.dto";
import {Observable, Subscription} from "rxjs";
import {StpRegistrationService} from "../../stp-registration/services/stp-registration.service";
import {StpRegistrationStorageService} from "../../stp-registration/services/stp-registration-storage.service";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class DashboardService{



  constructor(private apiService: ApiService, private http: HttpClient,
             ) {

  }

  getStpDashboardDetails(stpMainId: any): Observable<any> {
    const url = `${applicationUrls.commonService.stpDashboardDetails}/`+stpMainId;
    return this.apiService.get(url);
  }

  getStpDashboardOccupationCount(stpMainId: any): Observable<any> {
    const url = `${applicationUrls.commonService.getStpDashboardOccupationCount}/`+stpMainId;
    return this.apiService.get(url);
  }

}
